module.exports = __webpack_public_path__ + "img/list_Portrait_03.02f18d1d.jpeg";